<template>
  <div class="product-table">
      <div class="product-table-header">
        <div class="product-table-cell" style="min-width: 40px;">
        </div>
        <div v-for="(column, index) in columns" v-bind:key="index" :style="column.style" class="product-table-cell">
          {{ column.key }}
        </div>
      </div>
      <div class="product-table-content" v-if="typeof columnsIndexed !== 'undefined' && Object.keys(columnsIndexed).length > 0">
        <div v-for="(row, rowNumber) in rowsInternal" v-bind:key="rowNumber" class="product-table-row">
          <div style="min-width: 40px;" class="product-table-cell">
            <input type="checkbox" />
          </div>
          <div v-for="(col, colIndex) in columns" v-bind:key="colIndex" :style="typeof row[col.key] !== 'undefined' ? col.style : {}" class="product-table-cell">
            <span v-if="typeof row[col.key] !== 'undefined' && col.key !== 'image'">{{row[col.key]}}</span>
            <span v-if="typeof row[col.key] !== 'undefined' && col.key === 'image'">
              <img :src="row[col.key]" style="width: 100%" />
            </span>
          </div>
          <div class="product-table-row-extended-icon" @click="rowClicked(rowNumber)">
            <icon :icon="'caretUp'" v-if="row.extended"/>
            <icon :icon="'caretDown'" v-if="!row.extended"/>
          </div>
          <div class="product-table-row-extended" v-if="row.extended" v-html="row.extendedData" />
        </div>
      </div>
      <div class="product-table-footer">
        <div class="product-table-pagination" style="text-align: left; width: 50%; display: inline-block">
          <div v-if="typeof actionTitle !== 'undefined'">
            <button class="btn btn-primary" style="margin-left: 10px;">{{ actionTitle }}</button>
          </div>
        </div>
        <div class="product-table-pagination" style="text-align: right; width: 50%; display: inline-block">
          <div style="cursor: pointer; display: inline-block; padding: 10px 20px; border: 1px solid #eee; background-color: #fff; margin: 5px;" 
            v-for="i in pages" v-bind:key="i" 
            @click="changePage(i)">
            <span v-if="currentPage === i" style="font-weight: bold; text-decoration: underline">
            {{ i }}
            </span>
            <span v-if="currentPage !== i" >
            {{ i }}
            </span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from "vue";
import icon from "@/assets/icons/icons";

export default {
  name: "ProductTable",
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: false
    },
    page: {
      type: Number,
      required: false,
      default: 1
    },
    pages: {
      type: Number,
      required: false,
      default: 5
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1
    },
    changePageParent: {
      type: Function,
      required: false,
      default: function () {
        return false;
      }
    },
    actionTitle: {
      type: String,
      required: false
    },
    action: {
      type: Function,
      required: false,
      default: function () {
        return false;
      }
    }
  },
  data: function () {
    return {
      columnsIndexed: {},
      rowsInternal: []
    }
  },
  mounted: function () {
    // Create indexed array for the columns, using each attribute 'key' as the index
    for(var i in this.rows) {
      var row = this.rows[i];
      row.extended = false;
      Vue.set(this.rowsInternal, i, row);
    }
    
    // Create indexed array for the columns, using each attribute 'key' as the index
    for(var i in this.columns) {
      Vue.set(this.columnsIndexed, this.columns[i].key, this.columns[i]);
    }
  },
  methods: {
    rowClicked: function (rowNumber) {
      console.log(rowNumber);
      console.log(this.rowsInternal);
      var row = this.rowsInternal[rowNumber];
      row.extended = !row.extended;
      Vue.set(this.rowsInternal, rowNumber, row);
    },
    changePage: function (pageNumber) {
      console.log("page change " + pageNumber);
      this.changePageParent(pageNumber);
      /*this.rowsInternal.map((value, key) => {
        console.log(key);
        var row = this.rowsInternal[key];
        row.exteded = false;
        Vue.set(this.rowsInternal, key, row);
      })*/
    }
  },
  watch: { 
    rows: function(rows, oldVal) { // watch it
      console.log(rows);
      this.rowsInternal = rows;
      Vue.set(this.rowsInternal, rows);
    }
  },
  components: {
      icon
  }
};
</script>
